import React from 'react';
import { Space, Tag } from 'antd';

/** True when a row / item master marks inventory criticality. */
export function isItemCritical(
  row: { is_critical?: boolean | null | 0 | 1 | 'Y' | 'N' | 'y' | 'n' } | null | undefined
): boolean {
  if (row == null) return false;
  const v = row.is_critical;
  if (v === true || v === 1 || v === 'Y' || v === 'y') return true;
  if (v === false || v === 0 || v === 'N' || v === 'n' || v == null) return false;
  return Boolean(v);
}

/** Ant Design Table rowClassName for critical inventory lines. */
export function getCriticalItemRowClassName(
  row: { is_critical?: boolean | null | 0 | 1 | 'Y' | 'N' | 'y' | 'n' } | null | undefined,
  extra?: string
): string {
  const parts = [extra, isItemCritical(row) ? 'scm-critical-item-row' : ''].filter(Boolean);
  return parts.join(' ');
}

export function CriticalItemTag({
  critical,
  style,
}: {
  critical?: boolean | null;
  style?: React.CSSProperties;
}) {
  if (!critical) return null;
  return (
    <Tag color="red" style={{ marginInlineEnd: 0, ...style }}>
      Critical
    </Tag>
  );
}

/** Item code (or any label) with an optional Critical tag beside it. */
export function ItemCodeWithCritical({
  code,
  critical,
  fallback = '—',
}: {
  code?: string | null;
  critical?: boolean | null;
  fallback?: string;
}) {
  const label = String(code ?? '').trim() || fallback;
  if (!critical) return <>{label}</>;
  return (
    <Space size={6} wrap>
      <span>{label}</span>
      <CriticalItemTag critical />
    </Space>
  );
}
